<template>
    <modal-user-agreement :active="userAgreement" @close="hideModal" />
</template>
<script>
import ModalUserAgreement from './ModalUserAgreement';
import { mapActions, mapState } from 'vuex';

export default {
    name: 'modal-user-agreement-container',
    methods: {
        ...mapActions('modal', ['hide']),
        hideModal() {
            this.hide('userAgreement');
        },
    },
    computed: {
        ...mapState('modal', ['userAgreement']),
    },
    components: {
        ModalUserAgreement,
    }
}
</script>



// WEBPACK FOOTER //
// ModalUserAgreementContainer.vue?5ca0510c